<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Job Level Benefit Definition</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Job Level"
            v-model="jobLevel.jobDesc"
            :class="classPadding"
            clearable
            @click:clear="clearJobLevel"
            readonly
          >
            <template slot="append">
              <v-icon @click.stop="searchJobLevel">mdi-magnify</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12">
          <job-level-benefit-selection
            :show-dense="false"
            :show-select="true"
          ></job-level-benefit-selection>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="isSaving"
            :class="classPadding"
            @click.stop="save"
            v-if="userAccess.add >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
        <template slot="benefits" slot-scope="{ item }">
          <v-btn @click.stop="viewBenefits(item)" text outlined>View</v-btn>
        </template>
      </list>
    </v-container>
    <v-dialog v-model="jobLevelDialog" width="900">
      <v-card>
        <v-card-title>
          <span class="headline">Job Level</span>
        </v-card-title>
        <v-card-text>
          <job-level-pagination>
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="selectJobLevel(item)" text>Select</v-btn>
            </template>
          </job-level-pagination>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click.stop="jobLevelDialog = false"
            >close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="benefitDialog" width="500" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Job Level Benefit</span>
        </v-card-title>
        <v-card-text>
          <!-- selectedBenefitsH: [ -->
          <v-data-table
            dense
            @click:row="rowClick"
            :items="selectedBenefits"
            :headers="selectedBenefitsH"
          >
            <!-- <tbody>
              <tr v-for="(item, key) in selectedBenefits" :key="key">
                <td>{{ item.jobBenDesc }}</td>
                <td>{{ item.amount }}</td>
              </tr>
            </tbody>-->
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" width="700" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-text-field
              label="Job Level"
              v-model="editJobLevel.jobDesc"
              :class="classPadding"
              readonly
            >
              <!-- <template slot="append">
                <v-icon @click.stop="searchJobLevel">mdi-magnify</v-icon>
              </template>-->
            </v-text-field>
            <v-col cols="12" xs="12" sm="12" md="12">
              <job-level-benefit-selection
                :show-dense="false"
                :show-select="true"
              ></job-level-benefit-selection>
            </v-col>
          </v-row>
          <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
          </v-row>-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click.stop="editDialog = false"
            >Close</v-btn
          >
          <v-btn
            text
            color="success"
            @click.stop="update"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editAmountDialog" persistent scrollable width="500">
      <v-card>
        <v-card-title>
          <span></span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Benefit"
                :value="selectedBenefit.jobBenDesc"
                :class="classPadding"
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Amount"
                v-model="selectedBenefit.amount"
                :class="classPadding"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="editAmountDialog = false" text
            >close</v-btn
          >
          <v-btn color="success" @click.prevent="saveAmount" text>save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import JobLevelPagination from "../job-level/Pagination";
import JobLevelBenefitSelection from "../job-level-benefit/PaginationSelection";
import EventBus from "../../../../../events/eventBus";
import List from "./List";
import _ from "lodash";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/jobLevelBenDef";
const API_ENDPOINT_BEN = "/api/jobLevelBen";
export default {
  metaInfo: {
    title: "Job Level Benefit Definition",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    JobLevelPagination,
    JobLevelBenefitSelection,
    List
  },
  data: () => ({
    classPadding: "my-0 py-0",
    jobLevel: {},
    editJobLevel: {},
    jobLevelDialog: false,
    isSaving: false,
    jobLevelBenefits: [],
    componentKey: 0,
    editDialog: false,
    benefitDialog: false,
    selectedBenefits: [],
    selectedBenefit: {},
    selectedBenefitsH: [
      {
        text: "Benefit",
        value: "jobBenDesc",
        sortable: false
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false
      }
    ],
    isUpdating: false,
    editAmountDialog: false
  }),
  methods: {
    searchJobLevel() {
      this.jobLevelDialog = true;
    },
    selectJobLevel(item) {
      if (!this.editDialog) {
        this.jobLevel.jobDesc = item.jobDesc;
        this.jobLevel.jobCode = item.jobCode;
      } else {
        this.editJobLevel.jobDesc = item.jobDesc;
        this.editJobLevel.jobCode = item.jobCode;
      }
      this.jobLevelDialog = false;
    },
    clearJobLevel() {
      if (!this.editDialog) {
        this.jobLevel.jobDesc = null;
        this.jobLevel.jobCode = null;
      } else {
        this.editJobLevel.jobDesc = null;
        this.editJobLevel.jobCode = null;
      }
    },
    save() {
      this.isSaving = true;
      this.jobLevelBenefits.forEach(item => {
        item.jobCode = this.jobLevel.jobCode;
      });
      this.$axios
        .post(`${API_ENDPOINT}`, this.jobLevelBenefits)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editJobLevel.jobCode = rel.jobCode;
      this.editJobLevel.jobDesc = rel.jobDesc;
      this.editDialog = true;
      //var codes = map(item)
      this.getByJobCode(item.jobCode);
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.jobCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.jobLevel = {};
      this.forceRerender();
      this.editDialog = false;
      this.clearSelection();
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;
      this.jobLevelBenefits.forEach(item => {
        item.jobCode = this.editJobLevel.jobCode;
      });

      this.$axios
        .post(`${API_ENDPOINT}?mod=update`, this.jobLevelBenefits)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    clearSelection() {
      EventBus.$emit("CLEAR_JOBLEVEL_BEN");
    },
    viewBenefits(item) {
      this.getByJobCode(item.jobCode);
      this.benefitDialog = true;
    },
    getByJobCode(jobCode) {
      this.$axios
        .get(`${API_ENDPOINT}/${jobCode}`)
        .then(({ data }) => {
          this.selectedBenefits = data;
          if (!_.isEmpty(data)) {
            var codes = _.map(data, "jobBenCode");
            this.getBenefits(codes);
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getBenefits(codes) {
      this.$axios
        .post(`${API_ENDPOINT_BEN}/codes`, codes)
        .then(({ data }) => {
          EventBus.$emit("TOGGLE_SELECTED_JOBLEVEL_BEN", data);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    rowClick(value) {
      this.editAmountDialog = true;
      this.selectedBenefit = Object.assign({}, value);
      //this.viewDetails(value);
    },
    saveAmount() {
      this.$axios
        .put(`${API_ENDPOINT}`, this.selectedBenefit)
        .then(({ data }) => {
          this.editAmountDialog = false;
          this.benefitDialog = false;
          this.$toast.success(data.message);

          this.forceRerender();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    }
  },
  mounted() {
    EventBus.$on("SELECTED_JOBLEVEL_BEN", payload => {
      this.jobLevelBenefits = payload;
    });
  },
  created() {
    this.getUserAccessRights("JOBBNFTLVL");
  },
  watch: {
    editDialog(val) {
      if (!val) {
        this.clearSelection();
      }
    },
    benefitDialog(val) {
      if (!val) {
        this.clearSelection();
      }
    }
  }
};
</script>